import AbstractModule from './AbstractModule';

export class ProductSlider extends AbstractModule {
    constructor (target) {
        console.log('Module: ProductSlider has been loaded');

        super(target);

        this.$slider = this.$el.find('.js-slider');
        this.$thumbs = this.$el.find('.js-thumb-slider');

        this.initSlick();
    }

    initSlick () {
        this.$slider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            speed: 600,
            fade: true,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            asNavFor: '.js-thumb-slider',
        });

        this.$thumbs.slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            speed: 600,
            fade: false,
            focusOnSelect: true,
            // centerMode: true,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            asNavFor: '.js-slider',
        });
    }

    destroy () {

    }
}



// WEBPACK FOOTER //
// ./app/src/js/modules/ProductSlider.js